// extracted by mini-css-extract-plugin
module.exports = {"radioInputRow":"q_sg","radioInputColumn":"q_sh","inputOptionRow":"q_r7","inputOptionColumn":"q_r8"};